const uploadFetchAmazon = (fileId, file, onProgress, xhr) => {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('key', fileId);
        formData.append('AWSAccessKeyId', 'AKIAI2XJZFPKCC3PQKXA');
        formData.append('acl', 'public-read');
        formData.append('policy', 'CnsgImV4cGlyYXRpb24iOiAiMjAzMC0xMi0wMVQxMjowMDowMC4wMDBaIiwKICAiY29uZGl0aW9ucyI6IFsKICAgIHsiYnVja2V0IjogIm1vbGFiIiB9LAogICAgWyJzdGFydHMtd2l0aCIsICIka2V5IiwgIm1vbGFiLyJdLAogICAgeyJhY2wiOiAicHVibGljLXJlYWQiIH0KICBdCn0K');
        formData.append('signature', 'YdhIXcMzwrjsqKW4e0Vs7mmz4pk=');
        formData.append('file', file);
        if (!xhr) {
            xhr = new XMLHttpRequest();
        }
        const host = 'https://s3.amazonaws.com/molab/';
        xhr.open('POST', host);
        xhr.upload.addEventListener('progress', e => {
            if (e.lengthComputable) {
                const percent = Math.round(100 * e.loaded / e.total);
                onProgress(percent);
            }
        });
        xhr.addEventListener('load', () => resolve(host + fileId));
        xhr.addEventListener('error', () => reject());
        // throw new Error('test');
        xhr.send(formData);
    });
};

export default uploadFetchAmazon;


// WEBPACK FOOTER //
// ./src/utils/uploadFetchAmazon.js